import { useRouteLoaderData } from 'react-router'

import { ConsumerLandingPage } from '~/types/consumer'
import { ConsumerLoaderData } from '~/types/portal'

export const useLandingPage = (): ConsumerLandingPage => {
  const loaderData = useRouteLoaderData<ConsumerLoaderData>('routes/_docs/_index')
  const { landingPageData } = loaderData || {}

  return landingPageData || {}
}